const topics = [
  { label: '动作大片', hot: true, count: '2,386' },
  { label: '悬疑推理', hot: true, count: '1,854' },
  { label: '科幻巨制', hot: false, count: '1,620' },
  { label: '喜剧搞笑', hot: true, count: '2,103' },
  { label: '爱情文艺', hot: false, count: '1,447' },
  { label: '恐怖惊悚', hot: false, count: '1,289' },
  { label: '动画动漫', hot: true, count: '1,956' },
  { label: '纪录纪实', hot: false, count: '876' },
  { label: '经典老片', hot: false, count: '1,532' },
  { label: '日韩剧集', hot: true, count: '2,241' },
  { label: '欧美剧集', hot: false, count: '1,713' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-3">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            按类型探索你感兴趣的影视内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500/10 border-accent-500/30 hover:bg-accent-500/20 text-foreground-800'
                  : 'bg-background-50 border-background-200/60 hover:border-accent-500/20 text-foreground-600 hover:text-foreground-800'
              }`}
            >
              <span className="text-sm font-medium">{topic.label}</span>
              <span className="text-[11px] text-foreground-400 font-label">
                {topic.count}
              </span>
              {topic.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-fill text-[10px] text-accent-500"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}